import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'class-pass',
  template: `
    @if (hasClassPass) {
      <div class="flex align-items-center">
        <img
          src="/assets/img/classpass_compact.svg"
          alt="ClassPass booking"
          class="w-8rem h-3rem"
        />
      </div>
    } @else {
      <div class="flex align-items-center">
        <span>-</span>
      </div>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
export class ClassPassComponent implements OnInit {
  columnData: Observable<any> = new BehaviorSubject(null);
  keyName: Observable<any> = new BehaviorSubject(null);

  hasClassPass = false;

  ngOnInit(): void {
    this.columnData.subscribe((data: any) => {
      this.hasClassPass = data.cp_booking == '1' || data.class_pass == 1;
    });
  }
}
